























import { Vue, Component } from "vue-property-decorator";

@Component
export default class PasswordChangeAlert extends Vue {
  show: boolean = true;

  handleClick(event: any) {
    this.show = false;
    this.$router.push({ path: "/password_change" });
  }
}
